import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import Layout from '../components/Layout';
import { BASE_URL } from '../api';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const NAV = [
//   { icon: '⬡',  label: 'Dashboard',       path: '/dashboard'       },
//   { icon: '👥',  label: 'User Management', path: '/user-management'  },
//   // { icon: '🌤️', label: 'Season Name',      path: '/season-name'    },
//   // { icon: '📅',  label: 'Season Duration',  path: '/season-duration'   },
//   {
//     icon: '🌤️',
//     label: 'Season Management',
//     children: [
//       { icon: '🌤️', label: 'Season Name', path: '/season-name' },
//       { icon: '📅', label: 'Season Duration', path: '/season-duration' }
//     ]
//   },
//   {icon:'⏱️', label:'Rent Durations',  path:'/rent-durations'},
//   {
//     icon: '🚗',
//     label: 'Manage Car/Vehicle',
//     children: [
//       { icon: '🚗', label: 'Car Group', path: '/cargroup' },
//       { icon: '🚘',  label: 'Manage Cars',     path: '/manage-cars' }
//     ]
//   },
  
//   { icon: '📋',  label: 'Bookings',        path: '/bookings'        },
//   { icon: '🚘',  label: 'Vehicles',        path: '/vehicles'        },
//   { icon: '👤',  label: 'Customers',       path: '/customers'       },
//   { icon: '💳',  label: 'Payments',        path: '/payments'        },
// ];

export default function Dashboard() {
  const navigate  = useNavigate();
  const [user, setUser]                 = useState(null);
  const [date, setDate]                 = useState(new Date().toISOString().split('T')[0]);
  const [stats, setStats]               = useState({ availableVehicles:0, newBooking:0, onRent:0, pickup:0, returnToday:0, requestedCar:0, inquiry:0 });
  const [availRows, setAvailRows]       = useState([]);
  const [calData, setCalData]           = useState([]);
  const [month, setMonth]               = useState(new Date().toISOString().slice(0,7));
  const [activeBox, setActiveBox]       = useState('available');
  const [tableRows, setTableRows]       = useState([]);
  const [tableTitle, setTableTitle]     = useState('Available Vehicles');
  const [modal, setModal]               = useState(null);
  const [modalTitle, setModalTitle]     = useState('');
  const [sideOpen, setSideOpen]         = useState(true);
  const [activePage, setActivePage]     = useState('Dashboard');
  const [loading, setLoading]           = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    setUser(JSON.parse(localStorage.getItem('user')));
  }, []);

  useEffect(() => { fetchStats(); }, [date]);
  useEffect(() => { fetchCal();   }, [month]);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const r = await API.get(`/dashboard/stats?date=${date}`);
      setStats(r.data.stats);
      setAvailRows(r.data.availableRows);
      if (activeBox === 'available') setTableRows(r.data.availableRows);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const fetchCal = async () => {
    try {
      const r = await API.get(`/dashboard/calendar?month=${month}`);
      setCalData(r.data);
    } catch(e) { console.error(e); }
  };

  const fetchFilter = async (type, label) => {
    setActiveBox(type); setTableTitle(label);
    if (type === 'available') { setTableRows(availRows); return; }
    try {
      const r = await API.get(`/dashboard/filter?date=${date}&type=${type}`);
      setTableRows(r.data);
    } catch(e) { console.error(e); }
  };

  const fetchModal = async (type, id) => {
    try {
      const r = await API.post(`/dashboard/${type}`, { id });
      setModal(r.data);
      setModalTitle(type === 'booking' ? 'Booking Details' : type === 'inquiry' ? 'Inquiry Details' : 'Request Details');
    } catch(e) { console.error(e); }
  };

  const logout = () => { localStorage.clear(); navigate('/login'); };

  const prevMonth = new Date(month+'-01'); prevMonth.setMonth(prevMonth.getMonth()-1);
  const nextMonth = new Date(month+'-01'); nextMonth.setMonth(nextMonth.getMonth()+1);
  const curMonth  = new Date().toISOString().slice(0,7);

  const getDates = () => {
    const [y,m] = month.split('-').map(Number);
    const today = new Date(); today.setHours(0,0,0,0);
    const days = new Date(y,m,0).getDate();
    const dates = [];
    for(let d=1;d<=days;d++){
      const dt = new Date(y,m-1,d);
      if(dt>=today) dates.push(dt.toISOString().split('T')[0]);
    }
    return dates;
  };
  const monthDates = getDates();

  const pieData = {
    labels: ['New Bookings','On Rent','Pickup','Return','Available'],
    datasets:[{ data:[stats.newBooking,stats.onRent,stats.pickup,stats.returnToday,stats.availableVehicles],
      backgroundColor:['#6C63FF','#FF6584','#43BCCD','#F7B731','#26de81'], borderWidth:2, borderColor:'#fff' }]
  };
  const pieOpts = {
    responsive:true, maintainAspectRatio:true,
    plugins:{ legend:{ position:'bottom', labels:{ font:{ size:11, family:'DM Sans' }, padding:12 } },
      title:{ display:false } }
  };

  const STAT_CARDS = [
    { key:'available',   label:'Available',    value:stats.availableVehicles, color:'#26de81', bg:'#f0fff6', icon:'🟢' },
    { key:'newBooking',  label:'New Bookings', value:stats.newBooking,        color:'#6C63FF', bg:'#f3f2ff', icon:'📅' },
    { key:'onRent',      label:'On Rent',      value:stats.onRent,            color:'#FF6584', bg:'#fff2f5', icon:'🚗' },
    { key:'pickup',      label:'Pickup',       value:stats.pickup,            color:'#43BCCD', bg:'#f0fbfd', icon:'📍' },
    { key:'returnToday', label:'Returns',      value:stats.returnToday,       color:'#F7B731', bg:'#fffbf0', icon:'🔄' },
  ];

  return (
    <Layout activePage="Dashboard">
    <div style={S.root}>
     

      {/* ── Main ── */}
      <main style={S.main}>

        {/* Top bar */}
        <div style={S.topbar}>
          <div>
            <h1 style={S.pageHeading}>Dashboard</h1>
            <p style={S.pageSubtitle}>
              {new Date(date).toLocaleDateString('en-IN',{ weekday:'long', year:'numeric', month:'long', day:'numeric' })}
            </p>
          </div>
          <div style={S.topRight}>
            <div style={S.dateWrap}>
              <span style={S.calIcon}>📅</span>
              <input type="date" value={date} onChange={e=>setDate(e.target.value)} style={S.datePick} />
            </div>
            <div style={S.notifBell}>🔔</div>
          </div>
        </div>

        {/* Request / Inquiry pills */}
        <div style={S.pillRow}>
          {[
            { key:'request', label:'Requested Cars', value:stats.requestedCar, color:'#6C63FF' },
            { key:'inquiry', label:'Inquiries',       value:stats.inquiry,      color:'#FF6584' },
          ].map(p => (
            <button key={p.key} style={{ ...S.pill, borderColor: activeBox===p.key ? p.color:'#e0e0e0', background: activeBox===p.key ? p.color:'#fff', color: activeBox===p.key?'#fff':'#555' }}
              onClick={() => fetchFilter(p.key, p.label)}>
              {p.label}
              <span style={{ ...S.pillBadge, background: activeBox===p.key?'rgba(255,255,255,0.3)':'#f0f0f0', color: activeBox===p.key?'#fff':'#333' }}>{p.value}</span>
            </button>
          ))}
        </div>

        {/* Stat cards */}
        <div style={S.statGrid}>
          {STAT_CARDS.map(c => (
            <div key={c.key}
              style={{ ...S.statCard, background: activeBox===c.key ? c.color : c.bg,
                borderColor: activeBox===c.key ? c.color : 'transparent',
                transform: activeBox===c.key ? 'translateY(-4px)' : 'none',
                boxShadow: activeBox===c.key ? `0 8px 24px ${c.color}55` : '0 2px 8px rgba(0,0,0,0.06)' }}
              onClick={() => fetchFilter(c.key, c.label)}>
              <div style={S.statTop}>
                <span style={{ fontSize:24 }}>{c.icon}</span>
                <div style={{ ...S.statBadge2, background: activeBox===c.key?'rgba(255,255,255,0.25)':'rgba(0,0,0,0.06)', color: activeBox===c.key?'#fff':'#333' }}>
                  {c.value}
                </div>
              </div>
              <div style={{ ...S.statLabel, color: activeBox===c.key?'rgba(255,255,255,0.85)':'#888' }}>{c.label}</div>
            </div>
          ))}
        </div>

        {/* Chart + Table row */}
        <div style={S.midRow}>
          {/* Pie */}
          <div style={S.pieCard}>
            <h3 style={S.cardTitle}>Fleet Summary</h3>
            <Pie data={pieData} options={pieOpts} />
          </div>

          {/* Table */}
          <div style={S.tableCard}>
            <div style={S.tableHeader}>
              <h3 style={S.cardTitle}>{tableTitle}</h3>
              <span style={S.dateTag}>{date}</span>
            </div>
            {loading ? (
              <div style={S.loadingBox}>Loading…</div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={S.table}>
                  <thead>
                    <tr>
                      {activeBox === 'available'
                        ? ['Type','Name','Brand','Stock','On Rent','Available',''].map(h=><th key={h} style={S.th}>{h}</th>)
                        : tableRows[0] ? [...Object.keys(tableRows[0]).map(k=><th key={k} style={S.th}>{k}</th>), <th key="act" style={S.th}></th>] : null
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {activeBox === 'available'
                      ? availRows.map((r,i)=>(
                          <tr key={i} style={S.tr}>
                            <td style={S.td}>{r.group_name}</td>
                            <td style={S.td}>{r.car_name}</td>
                            <td style={S.td}>{r.car_brand}</td>
                            <td style={S.td}><span style={S.chip}>{r.total_stock}</span></td>
                            <td style={S.td}><span style={{ ...S.chip, background:'#fff2f5', color:'#FF6584' }}>{r.on_rent}</span></td>
                            <td style={S.td}><span style={{ ...S.chip, background:'#f0fff6', color:'#26de81' }}>{r.available_today}</span></td>
                            <td style={S.td}><button style={S.actionBtn}>Book</button></td>
                          </tr>
                        ))
                      : tableRows.map((r,i)=>(
                          <tr key={i} style={S.tr}>
                            {Object.values(r).map((v,j)=><td key={j} style={S.td}>{v}</td>)}
                            <td style={S.td}>
                              <button style={S.actionBtn} onClick={()=>fetchModal(
                                activeBox==='inquiry'?'inquiry':activeBox==='request'?'request':'booking',
                                r.id||r.bookingid||r.cont_Id||r.req_id
                              )}>View</button>
                            </td>
                          </tr>
                        ))
                    }
                    {tableRows.length===0 && activeBox!=='available' && (
                      <tr><td colSpan={8} style={{ textAlign:'center', padding:'32px', color:'#bbb', fontSize:14 }}>No records found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Calendar */}
        <div style={S.calCard}>
          <div style={S.calHeader}>
            <h3 style={S.cardTitle}>
              Car Availability —&nbsp;
              {new Date(month+'-01').toLocaleString('default',{month:'long',year:'numeric'})}
            </h3>
            <div style={S.calNav}>
              <button style={S.navBtn} disabled={month===curMonth} onClick={()=>setMonth(prevMonth.toISOString().slice(0,7))}>← Prev</button>
              <button style={S.navBtn} onClick={()=>setMonth(nextMonth.toISOString().slice(0,7))}>Next →</button>
            </div>
          </div>
          <div style={{ overflowX:'auto' }}>
            <table style={{ ...S.table, minWidth: 900 }}>
              <thead>
                <tr style={{ background:'#f8f7ff' }}>
                  <th style={{ ...S.th, minWidth:180, textAlign:'left' }}>Car</th>
                  {monthDates.map(d=>(
                    <th key={d} style={{ ...S.th, minWidth:36, textAlign:'center', padding:'8px 4px', fontSize:11 }}>
                      {new Date(d).getDate()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {calData.length===0
                  ? <tr><td colSpan={monthDates.length+1} style={{ textAlign:'center', padding:32, color:'#bbb' }}>Loading…</td></tr>
                  : (()=>{
                      let lastGroup='';
                      return calData.map((car,i)=>{
                        const rows=[];
                        if(car.group_name!==lastGroup){
                          lastGroup=car.group_name;
                          rows.push(
                            <tr key={`g-${i}`}>
                              <td colSpan={monthDates.length+1} style={S.groupRow}>{car.group_name}</td>
                            </tr>
                          );
                        }
                        rows.push(
                          <tr key={`c-${i}`} style={S.tr}>
                            <td style={{ ...S.td, display:'flex', alignItems:'center', gap:10 }}>
                              <img   src={`${BASE_URL}/${car.car_image}`}  alt={car.car_name} style={{ width:64, borderRadius:6, objectFit:'cover' }} />
                              <div>
                                <div style={{ fontWeight:600, fontSize:13, color:'#333' }}>{car.car_name}</div>
                                <div style={{ fontSize:11, color:'#999' }}>{car.car_transmission}</div>
                              </div>
                            </td>
                            {monthDates.map(d=>{
                              const booked = car.bookings?.[d]||0;
                              const avail  = car.total_stock - booked;
                              return (
                                <td key={d} style={{ textAlign:'center', padding:'6px 2px',
                                  background: avail<=0?'#fff2f5':avail<2?'#fffbf0':'#f0fff6',
                                  color: avail<=0?'#FF6584':avail<2?'#F7B731':'#26de81',
                                  fontWeight:700, fontSize:13 }}>
                                  {avail}
                                </td>
                              );
                            })}
                          </tr>
                        );
                        return rows;
                      });
                    })()
                }
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {/* ── Modal ── */}
      {modal && (
        <div style={S.overlay} onClick={()=>setModal(null)}>
          <div style={S.modalBox} onClick={e=>e.stopPropagation()}>
            <div style={S.modalHead}>
              <h3 style={{ margin:0, fontSize:16, fontWeight:700 }}>{modalTitle}</h3>
              <button style={S.closeBtn} onClick={()=>setModal(null)}>✕</button>
            </div>
            <div style={S.modalBody}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <tbody>
                  {Object.entries(modal).map(([k,v])=>(
                    <tr key={k} style={{ borderBottom:'1px solid #f0f0f0' }}>
                      <td style={{ padding:'10px 12px', color:'#888', fontSize:13, width:'40%', fontWeight:600 }}>{k}</td>
                      <td style={{ padding:'10px 12px', color:'#222', fontSize:13 }}>{v}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={S.modalFoot}>
              <button style={S.closeBtnFull} onClick={()=>setModal(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{ display:'flex', minHeight:'100vh', background:'#f4f6fb', fontFamily:"'DM Sans', 'Segoe UI', sans-serif" },

  
  /* Main */
  main:{ width:'100%' },

  /* Topbar */
  topbar:{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 },
  pageHeading:{ margin:0, fontSize:26, fontWeight:800, color:'#1a1d2e', letterSpacing:'-0.5px' },
  pageSubtitle:{ margin:'4px 0 0', fontSize:13, color:'#999' },
  topRight:{ display:'flex', alignItems:'center', gap:12 },
  dateWrap:{ display:'flex', alignItems:'center', gap:8, background:'#fff', border:'1px solid #e8e8e8',
    borderRadius:10, padding:'8px 14px', boxShadow:'0 2px 8px rgba(0,0,0,0.05)' },
  calIcon:{ fontSize:14 },
  datePick:{ border:'none', outline:'none', fontSize:13, fontWeight:600, color:'#333', fontFamily:'inherit', cursor:'pointer' },
  notifBell:{ width:40, height:40, background:'#fff', border:'1px solid #e8e8e8', borderRadius:10,
    display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:16,
    boxShadow:'0 2px 8px rgba(0,0,0,0.05)' },

  /* Pills */
  pillRow:{ display:'flex', gap:10, marginBottom:20 },
  pill:{ display:'flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:30,
    border:'1.5px solid', cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'inherit',
    transition:'all 0.2s' },
  pillBadge:{ borderRadius:20, padding:'2px 8px', fontSize:12, fontWeight:700 },

  /* Stat cards */
  statGrid:{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:14, marginBottom:24 },
  statCard:{ borderRadius:14, padding:'16px', cursor:'pointer', border:'2px solid transparent',
    transition:'all 0.22s', userSelect:'none' },
  statTop:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 },
  statBadge2:{ borderRadius:20, padding:'4px 12px', fontSize:18, fontWeight:800 },
  statLabel:{ fontSize:12, fontWeight:600, letterSpacing:'0.3px', textTransform:'uppercase' },

  /* Mid row */
  midRow:{ display:'grid', gridTemplateColumns:'300px 1fr', gap:20, marginBottom:24 },
  pieCard:{ background:'#fff', borderRadius:16, padding:'20px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)' },
  tableCard:{ background:'#fff', borderRadius:16, padding:'20px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', overflow:'hidden' },
  tableHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 },
  cardTitle:{ margin:0, fontSize:15, fontWeight:800, color:'#1a1d2e' },
  dateTag:{ fontSize:12, background:'#f3f2ff', color:'#6C63FF', borderRadius:20, padding:'4px 12px', fontWeight:600 },
  loadingBox:{ textAlign:'center', padding:'40px', color:'#bbb', fontSize:14 },

  /* Table */
  table:{ width:'100%', borderCollapse:'collapse' },
  th:{ padding:'10px 12px', fontSize:12, fontWeight:700, color:'#999', textAlign:'left',
    borderBottom:'2px solid #f0f0f0', textTransform:'uppercase', letterSpacing:'0.4px' },
  tr:{ transition:'background 0.15s', cursor:'default' },
  td:{ padding:'12px 12px', fontSize:13, color:'#333', borderBottom:'1px solid #f8f8f8' },
  chip:{ background:'#f3f2ff', color:'#6C63FF', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 },
  actionBtn:{ padding:'5px 14px', background:'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color:'#fff', border:'none', borderRadius:20, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:'inherit' },

  /* Calendar */
  calCard:{ background:'#fff', borderRadius:16, padding:'20px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)' },
  calHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 },
  calNav:{ display:'flex', gap:8 },
  navBtn:{ padding:'6px 14px', background:'#f3f2ff', color:'#6C63FF', border:'none',
    borderRadius:20, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:'inherit',
    transition:'background 0.15s' },
  groupRow:{ background:'linear-gradient(90deg,#6C63FF,#43BCCD)', color:'#fff',
    fontWeight:700, fontSize:12, padding:'8px 14px', letterSpacing:'0.5px', textTransform:'uppercase' },

  /* Modal */
  overlay:{ position:'fixed', inset:0, background:'rgba(10,10,30,0.55)', zIndex:999,
    display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(2px)' },
  modalBox:{ background:'#fff', borderRadius:20, width:560, maxWidth:'94vw', maxHeight:'85vh',
    display:'flex', flexDirection:'column', boxShadow:'0 24px 60px rgba(0,0,0,0.2)' },
  modalHead:{ display:'flex', justifyContent:'space-between', alignItems:'center',
    padding:'18px 22px', borderBottom:'1px solid #f0f0f0' },
  modalBody:{ padding:'8px 0', overflowY:'auto', flex:1 },
  modalFoot:{ padding:'16px 22px', borderTop:'1px solid #f0f0f0', textAlign:'right' },
  closeBtn:{ background:'#ff6b6b22', border:'none', color:'#ff6b6b', borderRadius:'50%',
    width:30, height:30, cursor:'pointer', fontWeight:800, fontSize:14 },
  closeBtnFull:{ padding:'8px 24px', background:'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color:'#fff', border:'none', borderRadius:20, cursor:'pointer', fontWeight:700, fontSize:13, fontFamily:'inherit' },
};